import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetEventsByLeagueId = QueryFactory(SD.QueryTypes.GetEventsByLeagueId);
//# sourceMappingURL=QGetEventsByLeagueId.js.map